module.exports = __webpack_public_path__ + "img/building_Artboard.8f43363a.png";